import React, { useEffect, useState } from "react";

import MainBlock from "../block4";
import MainBlockLoading from "../loading_block1";

const MediaPage2 = (props) => {
  const [state, setstate] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const url = new URL(
      window.api_url + "/media?media_type=" + props.media_type
    );


    console.log("my link is 1: " + url);
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    fetch(url, {
      method: "GET",
      headers,
    })
      .then((response) => response.json())
      .then((data) => {
        setstate(data);
        // console.log(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);
  // console.log("media page 2");
  // console.log(state);

  return (
    <React.Fragment>
      {isLoading ? (
        <MainBlockLoading />
      ) : (
        <>
          {state.map((e) => (
            <React.Fragment key={e.id}>
              {!props.FilteredData.filteredYear &&
                !props.FilteredData.filteredMonth ? (
                <MainBlock block_detail={e} FilteredData={props.FilteredData} />
              ) : (
                <>
                  {!props.FilteredData.filteredMonth ? (
                    <>
                      {e.date.split("-")[0] ==
                        props.FilteredData.filteredYear ? (
                        <>
                          <MainBlock
                            block_detail={e}
                            FilteredData={props.FilteredData}
                          />
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}

                  {e.date.split("-")[0] == props.FilteredData.filteredYear &&
                    e.date.split("-")[1] == props.FilteredData.filteredMonth ? (
                    <>
                      <MainBlock
                        block_detail={e}
                        FilteredData={props.FilteredData}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
            </React.Fragment>
          ))}
        </>
      )}
    </React.Fragment>
  );
};

export default MediaPage2;
